import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getTabsState = (state: RootState) => state.tabs;

export const getActiveTabIdSelector = createSelector(
  [getTabsState],
  (tabs) => tabs?.activeTabId,
);

export const getTabsStatusSelector = createSelector(
  [getTabsState],
  (tabs) => tabs?.tabsStatus,
);
